import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardPrice = ({ children, ...props }) => {
    return (React.createElement(Box, { width: "100%", align: "center", ...props }, children));
};
//# sourceMappingURL=ProductCardPrice.js.map